
import { useAct } from 'FlowBuilder/store'
import mergeTags from 'FlowBuilder/components/ActionForms/EmailToTarget/useEmailToTargetMergeTags'

export default function EditActionTemplate() {
  const act = useAct()
  const id = useSel(s => s.local.modal.actionTemplateId)
  const actionId = useSel(s => s.local.modal.actionId)
  const { name, subject, body } = useSel(s => id ? s.actionTemplates.entities[id] : { name: '', subject: '', body: '' })
  const [localName, setLocalName] = useState(name)
  const [localSubject, setLocalSubject] = useState(subject)
  const [localBody, setLocalBody] = useState(body)

  const label = id ? "Update" : "Add"
  const buttonDisabled = !localName

  function onUpdate() {
    const payload = {
      name: localName,
      subject: localSubject,
      body: localBody
    }

    if (id) {
      act.actionTemplates.upsert(id, payload)
    } else {
      act.actionTemplates.add({ ...payload, actionId, active: true })
    }

    act.local.closeModal()
  }

  return <div>
    <div className='row'>
      <div className='column remaining'>
        <div className='field margin-bottom'>
          <label className='bold'>Template name</label>
          <input
            type='text'
            value={localName}
            onChange={e => setLocalName(e.target.value)}
            className='full-width margin-top'
          />
        </div>

        <div className='field margin-bottom'>
          <label className='bold'>Subject line</label>
          <input
            type='text'
            value={localSubject}
            onChange={e => setLocalSubject(e.target.value)}
            className='full-width margin-top'
          />
        </div>

        <div className='field'>
          <label className='bold'>Content</label>
          <textarea
            value={localBody}
            onChange={e => setLocalBody(e.target.value)}
            className='full-width margin-top'
            rows={5}
          />
          <p className='smaller bold dark-grey'>You can use the following merge tags in this template:</p>
          <div className='merge-tag-list'>
            {mergeTags.map(mergeTag =>
              <div className='merge-tag'>{`{{${mergeTag.slug}}}`}</div>
            )}
          </div>
        </div>

        <div>
          <button className='button primary margin-top' onClick={onUpdate} disabled={buttonDisabled}>{label}</button>
        </div>
      </div>
    </div>
  </div>
}



